import { Column, Row } from 'src/shared/components/Semantic/all'
import { Card } from 'src/shared/components/ui/card'
import { useLocalization } from 'src/shared/hooks/useLocalization'

const AbstractCardBg = () => (
  <div
    className="pointer-events-none absolute inset-0 overflow-hidden rounded-[inherit]"
    aria-hidden
  >
    <svg
      className="absolute inset-0 h-full w-full"
      viewBox="0 0 800 360"
      preserveAspectRatio="xMidYMid slice"
    >
      <defs>
        <filter
          id="testimonial-soft"
          x="-40%"
          y="-40%"
          width="180%"
          height="180%"
        >
          <feGaussianBlur stdDeviation="16" />
        </filter>
      </defs>
      <rect width="800" height="360" fill="#ffffff" />
      <ellipse
        cx="-10"
        cy="-30"
        rx="130"
        ry="95"
        fill="#f5b73a"
        opacity="0.7"
        filter="url(#testimonial-soft)"
      />
      <ellipse
        cx="830"
        cy="-10"
        rx="90"
        ry="70"
        fill="#ff8a3d"
        opacity="0.45"
        filter="url(#testimonial-soft)"
      />
      <ellipse
        cx="860"
        cy="400"
        rx="140"
        ry="100"
        fill="#8b6cf0"
        opacity="0.62"
        filter="url(#testimonial-soft)"
      />
      <ellipse
        cx="40"
        cy="410"
        rx="90"
        ry="60"
        fill="#f4729a"
        opacity="0.28"
        filter="url(#testimonial-soft)"
      />
      <rect
        x="48"
        y="54"
        width="52"
        height="52"
        rx="16"
        fill="#f59e0b"
        opacity="0.2"
        transform="rotate(-18 74 80)"
      />
      <rect
        x="698"
        y="248"
        width="64"
        height="64"
        rx="20"
        fill="#7c5cde"
        opacity="0.16"
        transform="rotate(16 730 280)"
      />
      <circle cx="118" cy="268" r="7" fill="#f59e0b" opacity="0.5" />
      <circle cx="686" cy="86" r="5" fill="#7c5cde" opacity="0.4" />
      <circle
        cx="708"
        cy="108"
        r="11"
        fill="none"
        stroke="#7c5cde"
        strokeWidth="2"
        opacity="0.28"
      />
    </svg>
    <div className="absolute inset-0 opacity-[0.08] mix-blend-multiply [background-image:radial-gradient(rgba(40,30,20,0.45)_0.7px,transparent_0.7px)] [background-size:3px_3px]" />
  </div>
)

export const TestimonialCard = ({ testimonial, featured = false }) => {
  const { t } = useLocalization()

  const attribution = (
    <Row className="relative z-10 w-fit items-center gap-3.5">
      <img
        src={testimonial.image}
        alt={testimonial.name}
        className="h-20 w-20 shrink-0 rounded-md object-cover ring-1 ring-stone-300/70 ring-offset-2"
      />
      <Column className="min-w-0 items-start gap-0.5 text-left">
        <span className="text-md truncate font-normal">
          {testimonial.name}
        </span>
        <span className="text-md truncate text-slate-500">
          {t(testimonial.title)}
        </span>
      </Column>
    </Row>
  )

  if (featured) {
    return (
      <Card
        wrapperClassName="w-full"
        className="relative items-center gap-8 overflow-hidden !bg-white p-8 text-center md:p-12"
      >
        <AbstractCardBg />
        <blockquote className="relative z-10 m-0">
          <p className="text-lg leading-relaxed text-slate-700 md:text-xl">
            {t(testimonial.quote)}
          </p>
        </blockquote>
        {attribution}
      </Card>
    )
  }

  return (
    <Card
      wrapperClassName="min-w-0 w-full flex-1"
      className="min-w-0 flex-1 justify-between gap-6 p-5"
    >
      <blockquote className="m-0">
        <p className="text-lg leading-relaxed text-slate-700">
          {t(testimonial.quote)}
        </p>
      </blockquote>
      {attribution}
    </Card>
  )
}
